import React, { useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { useParams , useNavigate , useSearchParams} from 'react-router-dom';
import genStyles from '../../styles/General.module.css';
import {Button} from '@mantine/core';
import { fakeRecipeDetail } from '../../data/fakeData';
import OperationDetailsList from './operationDetailsList';
import styles from '../recipeDetails/recipeDetails.module.css'
import {getFormattedDateTime} from '../../utils/getFormattedDateTime'
import { InfoProps, OperationsRowType , Options} from '../../types/operations';
import { fakeInfo } from '../../data/fakeData';
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { useOperations } from '../../context/OperationsContext';
import { CreateOperationsMaps } from '../operations/OperationsMaps';
import { secondsInQuarter } from 'date-fns/constants';
import { CreateOptions } from '../recipeDetails/recipeOptions';
import { PositionData , InputPositionData } from '../../types/recipes';
import axios from 'axios';
import { Loader } from '@mantine/core';
import api from "../../api/axiosClient"

const Info = ({data}: { data: OperationsRowType | undefined }) =>{
    const [sorterMap, setSorterMap] = useState(new Map());
    const [beltMap, setBeltMap] = useState(new Map());
    const [recipeMap, setRecipeMap] = useState(new Map());
    const [statusMap, setStatusMap] = useState(new Map());

    useEffect(() => {
        const fetchMaps = async () => {
        const { sorterMap, beltMap, recipeMap, statusMap } = await CreateOperationsMaps();
        setSorterMap(sorterMap);
        setBeltMap(beltMap);
        setRecipeMap(recipeMap);
        setStatusMap(statusMap);
        };

        fetchMaps();
    }, [data]);

    return(
    <div className={styles.Info}>
        <div className={styles.FirstColumn}>
            <span className={styles.InfoHeader}> Sorter</span> 
            <span className={styles.InfoContent}> {sorterMap.get(data?.sorter_id||-1)} </span>
        </div>
        <div className={styles.SecondColumn}>
            <span className={styles.InfoHeader}> Belt </span> 
            <span className={styles.InfoContent}>{beltMap.get(data?.belt_id||-1)}  </span> 
        </div>
        <div className={styles.ThirdColumn}>
            <span className={styles.InfoHeader}> Recipe </span> 
            <span className={styles.InfoContent}>{recipeMap.get(data?.recipe_id||-1)}  </span> 
        </div>
        <div className={styles.FirstColumn}>
            <span className={styles.InfoHeader}> Start Date </span> 
                <span className={styles.InfoContent}> {getFormattedDateTime(new Date(data?.effective_from || ""))} </span> 
        </div>
        <div className={styles.SecondColumn}>
            <span className={styles.InfoHeader}> Status </span> 
            <span className={styles.InfoContent}>{statusMap.get(data?.status_id||-1)}  </span> 
        </div>
    </div>)
    }

const  OperationDetailsPage = () =>{
    const {opId} = useParams();
    const [searchParams] = useSearchParams();
    const recId = searchParams.get('recipeId');
    const navigate = useNavigate();
    const {operations} = useOperations()
    const [data, setData]=useState<PositionData []>()

    useEffect(() => {
        const fetchRecipesDetail = async () => {
        try {
            const response = await api.get(`/sorter/recipe/positions/get-by-recipe-id/${recId}`);
            const newData : PositionData []= (response.data as InputPositionData []).map(hopper => {
                        return {
                        id: hopper.position_id,
                        position: hopper.position,
                        product_color: hopper.product_color,
                        product_materials: hopper.product_materials,
                        colors:  hopper.colors.map(colorInfo => String(colorInfo.id)),
                        recycling_categories: hopper.recycling_categories.map(recInfo => String(recInfo.id)),
                        reuse_categories: hopper.reuse_categories.map(reuseInfo => String(reuseInfo.id)),
                        }
                    } )
            
            setData(newData);
        } catch (error) {
            console.error("Error fetching recipes:", error);
            setData([])
        }};
        fetchRecipesDetail();
      }, []);

    const matchedInfo = operations.find((element) => element.operation_id === Number(opId));

     const [options, setOptions] = useState<{
            color_options: Options[];
            recycling_options: Options[];
            reuse_options: Options[];
        }>({
            color_options:[],
            recycling_options:[],
            reuse_options:[],
        });
    
        useEffect(() => {
        if (!recId) return;
    
        const fetchOptions = async () => {
          const result = await CreateOptions(Number(recId)); 
          setOptions(result);
        };
    
        fetchOptions();
    }, [recId]);

     const content = data ? (
        <OperationDetailsList
            data={data}
            colorOpt={options.color_options}
            recyclingOpt={options.recycling_options}
            reuseOpt={options.reuse_options}
        />
    ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loader color="pink" />
        </div>

     );

    // <Button className ={genStyles.AddButton} variant="filled" color="#62929e" radius="xl">Export PDF</Button>
    return(
    <div>
        <PageTitle title="Sorting Details"></PageTitle>
        <div className={genStyles.PageMain}>
                <Info data={matchedInfo}></Info>
                {content}
                <div className={genStyles.AddButtonWrapper}> 
                    <Button className ={genStyles.AddButton} onClick={ () => {navigate(`/operations`)}} variant="outline" color="#474973" radius="xl">Cancel</Button>
                </div>
        </div>
    </div>
    );

}

export default OperationDetailsPage  